export enum LinkAction {
  DIALOG = 'dialog',
  PROFILE = 'profile',
  SEARCH = 'search',
  CREDITS = 'credits',
  MY_PROFILE = 'my-profile',
}

export enum ModalName {
  RESET_PASSWORD = 'reset-password',
  PACKAGES = 'packages',
  VIRTUAL_GIFTS = 'virtual-gifts',
  GALLERY = 'gallery',
}

export type RedirectLinkData = {
  action: {
    name: LinkAction,
    params: Record<string, any> | null
  }
  modal: {
    name: ModalName,
    params: Record<string, any> | null
  }
}